import { ApiService } from './ApiService';
import { IGetOneResponse } from '../util/Types/Generic';

export class MicrosoftService extends ApiService {
  static pathName = '/microsoft';

  static getInstallUrl = (): Promise<{ installUrl: string }> => {
    return this.get(`${this.pathName}`);
  };

  static completeMicrosoftAuth = (
    code: string,
  ): Promise<IGetOneResponse<{ success: boolean }>> => {
    return this.post(`${this.pathName}/oauth-callback`, {
      code,
    });
  };

  static getLinkStatus = (): Promise<
    IGetOneResponse<{
      status: 'pending' | 'completed';
    }>
  > => {
    return this.get(`${this.pathName}/status`);
  };

  static getProfile = (): Promise<IGetOneResponse<any>> => {
    return this.get(`${this.pathName}/access-tokens`);
  };

  static disconnect = (): Promise<IGetOneResponse<any>> => {
    return this.post(`${this.pathName}/disconnect`, {});
  };

  static refreshToken = (): Promise<IGetOneResponse<any>> => {
    return this.post(`${this.pathName}/refresh-token`, {});
  };
}
